// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Channel } from './channel';

export class ChannelInformation {
    channel: Channel;
    chatId: string;
}